import { render, staticRenderFns } from "./OtherFilters.vue?vue&type=template&id=bdf38636&scoped=true&"
import script from "./OtherFilters.vue?vue&type=script&lang=js&"
export * from "./OtherFilters.vue?vue&type=script&lang=js&"
import style0 from "./OtherFilters.vue?vue&type=style&index=0&id=bdf38636&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdf38636",
  null
  
)

export default component.exports